module.exports = __webpack_public_path__ + "static/media/banner-silver@2x.bcab6f58.jpg";